import { Pit11ProgressStepEnum } from '@/services/api-clients';


export function pit11ProgressStepNameFilter(step: Pit11ProgressStepEnum): string {
  switch (step) {
    case Pit11ProgressStepEnum.FetchingFiles: return 'Pobieranie plików';
    case Pit11ProgressStepEnum.CsvValidation: return 'Walidacja pliku CSV';
    case Pit11ProgressStepEnum.AssigningPdfToDrivers: return 'Przypisywanie PDF do kierowców';
    case Pit11ProgressStepEnum.SendingEmailsToDrivers: return 'Wysyłka maili do kierowców';
    case Pit11ProgressStepEnum.SendingLogs: return 'Wysyłka logów';
    case Pit11ProgressStepEnum.Completed: return 'Zakończono';
    default: return '';
  }
}
